/*
 * @Author: cc
 * @Date: 2022-03-08 14:33:08
 * @FilePath: \MCN_new\app\utils\uploadForZmy\avUploadService.js
 * @Description: 
 */
angular.module('mediaSelectorSeviceModule', []).factory('mediaSelectorSevice', [
    '$q',
    'modalDialog',
    function ($q) {
        let scope;

        /**
        * [initVideoUploader description]
        * @param   {[type]}  scopeInstance  [scope description]
        * @return  {[type]}         [return description]
        */
        function initVideoUploader(scopeInstance) {
            let defer = $q.defer();
                scope = scopeInstance;
                let uploaders = {
                    general: {
                        // onSuccess: onSuccess,
                        // onMD5Progress: onMD5Progress,
                        // onUploadProgress: onUploadProgress,
                        // onStartUpload: onStartUpload,
                        // onError: onError,
                        // onFileinQueue: onFileinQueue,
                        fastVideoInfo: {
                            status: '',
                        }
                    }
                };
                let instance = uploaders['general'];
                defer.resolve(instance);
            return defer.promise;
        }

        /**
         * [doUploader description] 执行上传
         * @return  {[type]}  [return description]
         */
        function doUploader() {
            generalUpLoad();
        }

        /**
        * [generalUpLoad description] 通用上传
        * @return  {[type]}  [return description]
        */
        function generalUpLoad() {
            scope.uploader.selectFile();
        }
        return {
            initVideoUploader: initVideoUploader,
            doUploader: doUploader,
        };

    },
]);
